import { RouteConfig } from 'vue-router';
import { AdminRoles } from '@/configs/role';

const adminRoutes: RouteConfig = {
  path: 'admin',
  component: () => import(/* webpackChunkName: 'dashboard.admin' */ '@/pages/admin/Index.vue'),
  redirect: {
    name: 'admin-list',
  },
  children: [
    {
      path: 'list',
      name: 'admin-list',
      component: () => import(/* webpackChunkName: 'dashboard.admin' */ '@/pages/admin/List.vue'),
      meta: {
        auth: true,
        roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor, AdminRoles.staff],
      },
    },
    {
      path: 'create',
      name: 'admin-create',
      component: () => import(/* webpackChunkName: 'dashboard.admin' */ '@/pages/admin/Edit.vue'),
      meta: {
        action: 'create',
        auth: true,
        roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor],
      },
    },
    {
      path: ':adminId/edit',
      name: 'admin-edit',
      component: () => import(/* webpackChunkName: 'dashboard.admin' */ '@/pages/admin/Edit.vue'),
      meta: {
        action: 'edit',
        auth: true,
        roles: [AdminRoles.root, AdminRoles.admin, AdminRoles.editor, AdminRoles.staff],
      },
    },
  ],
};

export default adminRoutes;
